import { z } from 'zod';
/** Scheduling (v2.0, Phase 15) — one-off appointments. Shared client↔server. */
export const APPT_MODALITIES = ['in_person', 'telehealth', 'hybrid'];
export const APPT_STATUSES = ['scheduled', 'completed', 'no_show', 'cancelled'];
const uuid = z.string().uuid();
export const appointmentCreateSchema = z
    .object({
    contactId: uuid,
    providerId: uuid.optional(),
    typeId: uuid.optional(),
    startsAt: z.coerce.date(),
    endsAt: z.coerce.date(),
    modality: z.enum(APPT_MODALITIES).default('in_person'),
    location: z.string().max(300).optional(),
})
    .refine((v) => v.endsAt > v.startsAt, {
    message: 'endsAt must be after startsAt',
    path: ['endsAt'],
});
export const appointmentUpdateSchema = z.object({
    providerId: uuid.nullable().optional(),
    typeId: uuid.nullable().optional(),
    startsAt: z.coerce.date().optional(),
    endsAt: z.coerce.date().optional(),
    modality: z.enum(APPT_MODALITIES).optional(),
    location: z.string().max(300).nullable().optional(),
});
// #138 - schedule a new appointment from the EHR contact drawer, written to the
// Calendar module via its API. `title`/`type` label the event; `providerId` is
// the clinician (a user id). No id: the server mints the calendar event id.
export const appointmentScheduleSchema = z
    .object({
    startsAt: z.coerce.date(),
    endsAt: z.coerce.date(),
    modality: z.enum(APPT_MODALITIES).default('in_person'),
    type: z.string().max(120).optional(),
    providerId: uuid.optional(),
    location: z.string().max(300).optional(),
    note: z.string().max(2000).optional(),
})
    .refine((v) => v.endsAt > v.startsAt, {
    message: 'endsAt must be after startsAt',
    path: ['endsAt'],
});
//# sourceMappingURL=scheduling.js.map